import * as React from 'react';

import { makeStyles, Theme } from '@material-ui/core/styles';

import { Typography } from '../../atoms';

export type InlineBulletListProps = {
  notes: string[];
};

const useStyles = makeStyles((theme: Theme) => ({
  inlineBulletList: {
    alignItems: 'center',
    display: 'flex',
    flexFlow: 'row wrap',
    justifyContent: 'flex-start',
    listStyleType: 'none',
    margin: 0,
    paddingLeft: 0,
  },

  inlineBulletListItem: {
    alignItems: 'center',
    display: 'flex',
    flexFlow: 'row nowrap',
    paddingLeft: 0,
    paddingRight: theme.spacing(1.5),

    '&::before': {
      color: theme.palette.grey[600],
      content: '"\\00b7"',
      display: 'inline-block',
      fontSize: theme.typography.pxToRem(24),
      lineHeight: theme.typography.pxToRem(16),
      textIndent: `-9px`,
    },

    '&:first-of-type': {
      '&::before': {
        content: '""',
      },
    },
  },

  [theme.breakpoints.up('md')]: {
    inlineBulletList: {
      padding: 0,
    },
  },
}));

export function InlineBulletList(props: InlineBulletListProps): JSX.Element {
  const { notes } = props;

  const classes = useStyles();

  if (!notes) {
    return null;
  }

  return (
    <ul className={classes.inlineBulletList}>
      {notes.map((note, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <li className={classes.inlineBulletListItem} key={`${note}-${index}`}>
          <Typography variant="body2-secondary">{note}</Typography>
        </li>
      ))}
    </ul>
  );
}
